import React, { useState,useEffect} from 'react'
import './Nav.css';

function Nav() {

  const [show, handleShow]= useState(false);

   useEffect(() => {
    window.addEventListener("scroll", ()=>{
        if(window.scrollY>100)
        {
              handleShow(true);
        }else handleShow(false);
    });

    return () =>{
        window.removeEventListener("scroll");
    };



   }, []);



    return (
        <div className={`nav ${show && "nav__black"}`}>
            <img
              className="nav__logo"
              src="https://i1.wp.com/freepngimages.com/wp-content/uploads/2016/10/netflix-logo.png?fit=895%2C559"
              alt="Netflix Logo"

           />
       
           <img
              className="nav__avatar"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS72hvVhDtEiGMySuNj2KKTbrlUY73qcIQZkg&usqp=CAU"
              alt="Netflix Logo"

           />



        </div>
    )
}

export default Nav
